import { useCallback } from "react";
import { deleteActiveUser } from '../services/loginPrerequisiteService';
import { removeLocalStorageItems } from '../utils/removeLocalStorageUtility';
import { IdpApi } from '../utils/idpApi';

/**
 * React hook for logout cleanup and navigation.
 * Usage: const logoutCleanup = useLogoutCleanup(); await logoutCleanup(SHVAToken, globalRedirectURL, navigate);
 */
export default function useLogoutCleanup() {
  return useCallback(async (SHVAToken, globalRedirectURL, navigate) => {
    // Set shva if not present
    if (!localStorage.getItem('shva') || localStorage.getItem('shva') === 'undefined' || localStorage.getItem('shva') === '') {
      localStorage.setItem('shva', SHVAToken);
    }

    const signinlog = "SignOut, Success, HealthViewAnalyticsUI";
    try {
      await deleteActiveUser(signinlog);
    } catch (error) {
      // Optionally handle error
    }

    removeLocalStorageItems();
    sessionStorage.clear();
    if (globalRedirectURL && globalRedirectURL !== '') {
      //IdpApi.logout(adalAuthenticationService, customIDPAuthenticationService, redirectUri);
      // Optionally redirect using globalRedirectURL
    } else {
      //IdpApi.logout(adalAuthenticationService, customIDPAuthenticationService, "");
      navigate('/'); // React navigation to home
    }
  }, []);
}